var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.title,"size":"xl","hide-footer":""}},[_c('span',{staticClass:"mb-4"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Media item ID ")]),_vm._v(" "+_vm._s(_vm.media_id)+" ")]),_c('b-table',{staticClass:"mt-3",attrs:{"items":_vm.items,"fields":_vm.fields,"striped":"","small":"","borderless":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }